import semver from 'semver';
import UAParser from 'ua-parser-js';

import Monitoring from 'shared_modules/Monitoring';

export const OsDeprecationMessages = {
  MAC: 'Upgrade your current macOS system to the latest version to continue using Lightspeed Hub.',
  WINDOWS: 'Windows 7 is no longer supported by Microsoft.',
};

export const getOperatingSystem = () => {
  const operatingSystem = UAParser(navigator.userAgent).os;
  return operatingSystem;
};

export const getIsUnsupportedOS = ():
  | { isOSVersionSupported: boolean; msg?: string }
  | undefined => {
  try {
    const { name, version } = getOperatingSystem();

    if (name && version) {
      if (name.match('Mac') && !semver.satisfies(version, '>=10.15')) {
        // support for versions 10.15 (Catalina) and up
        return {
          isOSVersionSupported: false,
          msg: OsDeprecationMessages.MAC,
        };
      }

      if (name.match('Windows') && !semver.satisfies(version, '>=8.1')) {
        // support for versions 8.1 and above
        return {
          isOSVersionSupported: false,
          msg: OsDeprecationMessages.WINDOWS,
        };
      }

      return { isOSVersionSupported: true };
    }
  } catch (err) {
    Monitoring.NRError(err, 'getIsUnsupportedOs', { reason: 'Could not retrieve OS version' });
  }

  return undefined;
};
